export default __webpack_public_path__ + "static/media/icon_10.989ad13a.png";